import AmplifiersChart from "./AmplifiersChart";

export default AmplifiersChart;
